import { render } from "./completed-interviews.vue?vue&type=template&id=bfed801a&ts=true"
import script from "./completed-interviews.vue?vue&type=script&lang=ts"
export * from "./completed-interviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__